import type { IconNode } from '../types';

/**
 * @name case-snake
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNyAxMXY1IiAvPgogIDxjaXJjbGUgY3g9IjQuNSIgY3k9IjEzLjUiIHI9IjIuNSIgLz4KICA8cGF0aCBkPSJNMTEgMTZoMiIgLz4KICA8Y2lyY2xlIGN4PSIxOS41IiBjeT0iMTMuNSIgcj0iMi41IiAvPgogIDxwYXRoIGQ9Ik0xNyA5djciIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/case-snake
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const caseSnake: IconNode = [
  ['path', { d: 'M7 11v5', key: '1b1nj6' }],
  ['circle', { cx: '4.5', cy: '13.5', r: '2.5', key: '7snsj1' }],
  ['path', { d: 'M11 16h2', key: '3xe00a' }],
  ['circle', { cx: '19.5', cy: '13.5', r: '2.5', key: '1vs2hw' }],
  ['path', { d: 'M17 9v7', key: '1bcczg' }],
];

export default caseSnake;
